<template>
    <div>
        <canvas id="canvas" ref="canvas"></canvas>
    </div>
</template>

<script>
    import Chart from "chart.js";
    import ChartDataLabels from 'chartjs-plugin-datalabels';
    Chart.plugins.unregister(ChartDataLabels);

export default {
    name:"ChartLine",

    props: {
            datasets: {},
            labels: {},
            'headline': {
                default: 'Headline',
            },
            colors: {
                default:() => ([
                    '#F1948A',
                    '#F9E79F',
                    '#FAD7A0',
                ]),
            }
        },


        watch: {
            json() {
                this.chart();
            }
        },


        computed: {
            json() {
                return {
                    type:'line',
                    data: {
                        labels: this.labels,
                        datasets: this.datasets,
                    },
                    options: {
                        responsive: true,
                        plugins: {
                            datalabels: {
                            }
                        },
                        legend: {
                            display: true,
                        },
                        title: {
                            display: false,
                            text: 'Chart.js Line Chart'
                        },
                        scales: {
                            xAxes: [{
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Zeit'
                                }
                            }],
                            yAxes: [{
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Anzahl'
                                },
                                ticks: {
                                beginAtZero: true,
                                precision:0

                                }
                            }],
                            x: {
                                title: {
                                    display: true,
                                    text: 'Anzahl'
                                },
                            },
                            y: {
                                title: {
                                    display: true,
                                    text: 'Zeit'
                                },
                                
                            }
                        }
                    }
                };
            }
        },

        mounted() {
            this.chart()
        },

        methods: {
            chart() {
                new Chart(this.$refs.canvas, this.json);
            }
        }
    }
</script>

<style scoped>

</style>